import { LayoutDashboard, ArrowLeftRight, CalendarDays, ClipboardList } from "lucide-react";

// Configurações não entra aqui: acessada só pelo ícone de engrenagem no Topbar.
// Contas e cartões também não: acessada pelo link abaixo do saldo consolidado no Dashboard.
export const navItems = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/lancamentos", label: "Lançamentos", icon: ArrowLeftRight },
  { to: "/calendario", label: "Calendário", icon: CalendarDays },
  { to: "/metas", label: "Planejamento", icon: ClipboardList },
];
